import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/loker',
    name: 'loker',
    component: () => import('../views/loker/loker.vue'),
  },
  {
    path: '/isiLoker',
    name: 'isiLoker',
    component: () => import('../views/loker/isiLoker.vue'),
  },
  {
    path: '/berita',
    name: 'berita',
    component: () => import('../views/berita/berita.vue'),
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: () => import('../views/berita/isiBerita.vue'),
  },

  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
